import { gql } from '@apollo/client'

export const GET_AUTHED_USER = gql`
  query GetAuthedUser {
    authed_user {
      id
      created_at
      email
      first_name
      last_name
      disabled
      profile_image_url
      notification_enabled
      status
      isAvailable
      intercom_user_hash
      user_role {
        id
        role {
          id
          name
          description
          role_permission {
            id
            permission {
              id
              name
            }
          }
          role_permission_group {
            id
            permission_group {
              id
              name
              permission {
                id
                name
              }
            }
          }
        }
      }
      user_system_role {
        id
        system_role {
          id
          name
          description
          system_role_permission {
            id
            system_permission {
              id
              name
            }
          }
          system_role_permission_group {
            id
            system_permission_group {
              id
              name
              system_permission {
                id
                name
              }
            }
          }
        }
      }
      user_account {
        id
        account {
          id
          name
          created_at
          enable_post_moveout_product
          is_pay_ready
          is_res_center
          stripe_account_id
          total_units
          pay_ready_account_xref {
            id
            buzz_login_retired
          }
          account_integrations {
            id
            integration {
              id
            }
          }
        }
      }
      user_property {
        id
        property {
          id
          name
          enable_post_moveout
        }
      }
      twilio_worker_id
      actual_user {
        id
        email
        first_name
        last_name
      }
      pay_ready_user {
        id
        eviction_access
        recovery_access
        resident_access
        user_type
      }
    }
  }
`

export const GET_USERS = gql`
  query getUsers {
    users {
      id
      first_name
      last_name
      user_property {
        id
        property {
          id
          name
        }
      }
    }
  }
`
export const GET_VOICE_TOKEN = gql`
  query CreateVoiceToken {
    createVoiceToken
  }
`

export const GET_CONVERSATION_COUNTS = gql`
  query GetConversationCounts {
    conversationCounts {
      id
      rescom
      leasing
      other
    }
  }
`

export const GET_MY_INBOX_COUNT = gql`
  query GetMyInboxCount($claimed_id: Int) {
    myInboxCount(claimed_id: $claimed_id) {
      id
      claimed_id
      count
    }
  }
`

export const GET_NOTIFICATIONS = gql`
  query GetNotifications($user_id: Int!) {
    notifications(user_id: $user_id) {
      id
      type
      title
      description
      action_url
      is_read
      created_at
      assigned_by {
        first_name
        last_name
        profile_image_url
      }
    }
  }
`
export const GET_ALL_PERMISSION = gql`
  query Permissions {
    permissions {
      id
      name
      permission_group {
        id
        name
      }
    }
  }
`

export const GET_PROPERTIES = gql`
  query GetPropertiesForMenu {
    properties {
      id
      name
    }
  }
`
